var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 14.4C1.96 14.4 1.58333 14.2433 1.27 13.93C0.956667 13.6167 0.8 13.24 0.8 12.8V2.4H0V0.8H4V0H8.8V0.8H12.8V2.4H12V12.8C12 13.24 11.8433 13.6167 11.53 13.93C11.2167 14.2433 10.84 14.4 10.4 14.4H2.4ZM10.4 2.4H2.4V12.8H10.4V2.4ZM4 11.2H5.6V4H4V11.2ZM7.2 11.2H8.8V4H7.2V11.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.62f2fd27728cc453ee10cb1658293e42.svg";
export { ForwardRef as ReactComponent };